import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectDeletingUserFromState = (state: RootState): boolean =>
  state.app.profile.profileDelete.deletingUser
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.profile.profileDelete.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.profile.profileDelete.errorDetailMap
